<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
<div class="container">
  <div class="row" *ngIf="myclinic && myclinic.length>0;else noClinic">
      <div class="col-12 text-center">
          <mat-tab-group >
              <mat-tab *ngFor="let cl of myclinic " label={{cl.name}}>
              <div class="row"  style="margin-top:15px" *ngIf="appointment && walkin">
                      <div class="col-5" >
                          <p class="card-header text-center" style="background:#9b7544;color:#fff; width:100%">
                              <th>Online Appointment</th>
                             </p>
                          <table  class="table table-bordered" style="text-align: center;border:#cb983f 2px solid;
                          " *ngIf="checkAppointtmentLength(cl.id); else noapp">
                                  
                                     <tr>
                                        <th>Start Time</th>
                                        <th>Pet Name with the pet parent's name</th>
                                        <th>Manage</th>
                                        <!--<th>Payment Mode</th>
                                        <th>Payment Status</th>-->
                                       </tr>
                                     <tbody *ngFor="let ap of appointment">
                                       <tr *ngIf="ap.clinic_id == cl.id" >
                                         <td >
                                          {{ap.start_time}}
                                         </td>
                                      
                                         <td >  
                                            <a *ngFor="let p of pets">
                                                <a *ngFor="let a of allusers">
                                             <a *ngIf="ap.pet_id === p.id && ap.user_id === a.user_id">                                       
                                            {{p.pet_name}} ({{a.name}})
                                             </a>
                                        </a>
                                      </a>
                                         </td>
                                         <td>    
                                                  <button class="btn btn-link btn-sm"   (click)="updateStatus(cl.id, ap.id, 'Shown')"> Checkup done</button>
                                              
                                                <!--  <button class="btn btn-link btn-sm" style="color: red"  (click)="updateStatus(cl.id, ap.id, 'Not shown')"> Patient didn't show up</button>  -->
                                         </td>
                                       <!--  <td>
                                            {{ap.payment_mode}}
                                         </td>
                                         <td>
                                            {{ap.payment_status}}
                                         </td>-->
                                       </tr>
                                    </tbody>
                              </table>
                      </div>
                      <div class="col-1"></div>
                <div class="col-6 center text-center" >
                    <p class="card-header text-center" style="background:#dfc473;color:black">
                        <th>Walkin</th>
                    </p>
                    <table  class="table table-bordered" style="text-align: center;border:black 2px solid;
                    " *ngIf="checkWalkinLength(cl.id);else nowalkin">
                            
                               <tr>
                                  <th>Token</th>
                                  <th>Pet Name with the pet parent's name</th>
                                  <th>Manage</th>
                                </tr>
                               <tbody *ngFor="let token of walkin" style="height: 100px" >
                                 <tr *ngIf="token.clinic_id == cl.id" >
                                   <td >
                                    {{token.token}}
                                   </td>
                                   <td >  
                                      <a *ngFor="let p of pets">
                                          <a *ngFor="let a of allusers">
                                       <a *ngIf="token.pet_id === p.id && token.user_id === a.user_id">                                       
                                      {{p.pet_name}} ({{a.name}})
                                       </a>
                                  </a>
                                </a>
                                   </td>
                                   <td>
                                      
                                      <tr>
                                     
                                            <button class="btn btn-link btn-sm"   (click)="updateClinicWalkinStatus(cl.id, token.id,'Shown')" > Checkup done</button>
                                    
                                       <!--     <button class="btn btn-link btn-sm"  style ="color: red"(click)="updateClinicWalkinStatus(cl.id, token.id,'Not shown')" > Patient didn't show up</button> -->
                                        
                                          </tr>   
                                   
                                      </td>
                                 </tr>
                              </tbody>
                        </table>
                  </div>
                    <!--  <div class="col-12 text-center" *ngIf="start !=1">
                        <button class="btn btn-outline-success btn-block" (click)="getNextAppointment(cl.id)">Start Appointment</button>
                      </div>-->
              </div>
              </mat-tab>
          </mat-tab-group>
        </div>
      </div>
      
    </div>
    <ng-template #nowalkin>
        <div class="row" style="margin-top:5px">
          <div class="col-12 text-center">
            <p style="font-style:open sans; color:#9b7544">No Walkin Today</p>
          </div>
        </div>
    </ng-template>
    <ng-template #noapp>
        <div class="row" style="margin-top:5px">
          <div class="col-12 text-center">
            <p style="font-style:open sans; color:#9b7544">No Appointment Today</p>
          </div>
        </div>
    </ng-template>
    <ng-template #noClinic>
      <div class="row" style="margin-top:5px">
        <div class="col-12 text-center">
         <h4> <p style="font-style:open sans; color:#9b7544">No clinic found Today</p></h4>
        </div>
      </div>
  </ng-template>